import React from 'react';
import { IconProps } from '../types/types';

const CADCHF: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 38 41" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <circle cx={13.346} cy={13.34} fill="#fff" r={13.34} />
        <path d="M13.34 26.68c7.367 0 13.34-5.972 13.34-13.34C26.68 5.973 20.707 0 13.34 0S0 5.973 0 13.34c0 7.368 5.973 13.34 13.34 13.34Z" fill="#F0F0F0" />
        <path
            d="M0 13.34c0 5.289 3.078 9.859 7.54 12.016V1.324C3.078 3.48 0 8.05 0 13.34ZM26.645 13.34c0 5.289-3.078 9.859-7.54 12.016V1.324c4.462 2.157 7.54 6.727 7.54 12.016ZM15.661 15.08l2.32-1.16-1.16-.58v-1.16l-2.32 1.16 1.16-2.32h-1.16l-1.16-1.74-1.16 1.74h-1.16l1.16 2.32-2.32-1.16v1.16l-1.16.58 2.32 1.16-.58 1.16h2.32v1.74h1.16v-1.74h2.32l-.58-1.16Z"
            fill="#D80027"
        />
        <circle cx={24.333} cy={27.167} fill="#fff" r={13.331} />
        <path d="M24.331 40.498c7.363 0 13.332-5.968 13.332-13.331 0-7.363-5.969-13.332-13.332-13.332C16.97 13.835 11 19.805 11 27.167c0 7.363 5.969 13.331 13.331 13.331Z" fill="red" />
        <path d="M22.004 21h3.75v4.375h4.375v3.75h-4.375V33.5h-3.75v-4.375h-4.375v-3.75h4.375V21Z" fill="#fff" />
    </svg>
);

export default CADCHF;
